import { ROUTES_WELCOME } from '@/constants/routes';

export default {
    path: '/welcome',
    name: ROUTES_WELCOME,
    component: () => import(/*webpackChunkName: 'welcome'*/ '@/views/Welcome.vue')
};
